import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppUser } from "../../types/User";

interface AuthState {
  user: AppUser | null;
  loading: boolean; // true while auth handshake is active
  loadedFromFirestore: boolean; // true after we attempted to read Firestore doc (success/error)
  roleConfirmed: boolean; // true when authoritative Firestore snapshot confirmed role
}

const initialState: AuthState = {
  user: null,
  loading: true,
  loadedFromFirestore: false,
  roleConfirmed: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<AppUser>) {
      state.user = action.payload;
      // auth handshake considered complete when we set a user
      state.loading = false;
      // do NOT set loadedFromFirestore or roleConfirmed here; caller should set explicitly
    },
    clearUser(state) {
      state.user = null;
      state.loading = false;
      state.loadedFromFirestore = true; // unblock UI and allow redirect to login
      state.roleConfirmed = false; // clear role confirmation on sign-out
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setLoadedFromFirestore(state, action: PayloadAction<boolean>) {
      state.loadedFromFirestore = action.payload;
    },
    // NEW: only set to true when authoritative onSnapshot arrives
    setRoleConfirmed(state, action: PayloadAction<boolean>) {
      state.roleConfirmed = action.payload;
    },
  },
});

export const { setUser, clearUser, setLoading, setLoadedFromFirestore, setRoleConfirmed } =
  authSlice.actions;
export default authSlice.reducer;
